/**
 * Exposes an element's scope as an HTML5 data DOM property.
 * Usage: const myScope = angular.element(ele).data('$scope');
 */
export default () => ({
	restrict: 'A',
	scope: false,
	link: (scope, elem) => elem.data('$scope', scope)
});
